/*******************************************************************************************************/
/* CUSTOM OUTSIDE DOM SCRIPTS
/*******************************************************************************************************/


/*******************************************************************************************************/
/* CUSTOM DOM READY SCRIPTS
/*******************************************************************************************************/

// Please be careful to add your custom scripts to this call and don't create too much $(function(){}) or document.ready()
$(function() {

    // WP-23906 prevent hover mechanism on french-days entry
    if ($('#menu_french-days').length) {
        $('#menu_french-days').parent('.main_menu_itm').addClass('itm_no_rollhover');
        $('#menu_french-days').parent('.main_menu_itm').attr('onmouseenter', '');
        $('#menu_french-days').parent('.main_menu_itm').attr('onmouseleave', '');
    }

    // SW-17955 prevent hover mechanism on giveme-5five entry
    if ($('#menu_giveme-5five').length) {
        $('#menu_giveme-5five').parent('.main_menu_itm').addClass('itm_no_rollhover');
        $('#menu_giveme-5five').parent('.main_menu_itm').attr('onmouseenter', '');
        $('#menu_giveme-5five').parent('.main_menu_itm').attr('onmouseleave', '');
    }

    // Init preheader promo_swiper
    if ($('.promo_swiper').length && ($('.promo_swiper .swiper-slide').length > 1)) {
        new Swiper('.promo_swiper', {
            slidesPerView: 1,
            autoplay: true,
            speed: 1000,
            loop: true
        })
    }

    if ($('#content_pdvBox .content_store_locator').length) {
        $('#content_pdvBox .content_store_locator').overlayScrollbars({});
    }

    /********** HOMEPAGE **********/
    if ($('#sliderCoverModule .swiper-container .swiper-slide').length > 1) {
        var coverHomeSwiper = new Swiper('#sliderCoverModule .swiper-container', {
            preloadImages: false,
            lazy: true,
            loop: true,
            speed: 1500,
            autoplay: {
                delay: 3000,
            },
            pagination: {
                el: '.swiper-pagination',
                type: 'bullets',
            },
        });

        //Autostop on hovering
        $("#sliderCoverModule .swiper-container").hover(function() {
            (this).swiper.autoplay.stop();
        }, function() {
            (this).swiper.autoplay.start();
        });
    }

    /********** CMS PAGE SLIDER COVER MODULE **********/
    $('.cms-page-module-body.slider-cover-module.module-27-picture-only .cms-slider-items').each(function() {
        var $swiperContainer = $(this);
        var slideCount = $swiperContainer.find('.swiper-slide').length;
        var $pagination = $swiperContainer.parent().find('.swiper-container + .swiper-pagination');
        var $navNext = $swiperContainer.siblings('.swiper-button-next');
        var $navPrev = $swiperContainer.siblings('.swiper-button-prev');

        // Hide navigation and pagination if there is only 1 slide (slidesPerView: 1)
        if (slideCount <= 1) {
            $pagination.hide();
            $navNext.hide();
            $navPrev.hide();
        }

        var cmsCoverSwiper = new Swiper($swiperContainer[0], {
            preloadImages: false,
            lazy: true,
            speed: 1500,
            autoplay: {
                delay: 3000,
            },
            navigation: {
                nextEl: $swiperContainer.siblings('.swiper-button-next')[0],
                prevEl: $swiperContainer.siblings('.swiper-button-prev')[0],
            },
            pagination: {
                el: $swiperContainer.parent().find('.swiper-container + .swiper-pagination')[0],
                type: 'progressbar',
            },
        });

        //Autostop on hovering
        $swiperContainer.hover(function() {
            (this).swiper.autoplay.stop();
        }, function() {
            (this).swiper.autoplay.start();
        });
    });

    /********** CMS PAGE MODULE 28 PICTURE TEXT CTA **********/
    $('.cms-page-module-body.module-28-picture-text-cta .cms-slider-items').each(function() {

        var $swiperContainer = $(this);
        var slideCount = $swiperContainer.find('.swiper-slide').length;
        var $pagination = $swiperContainer.parent().find('.swiper-container + .swiper-pagination');
        var $navNext = $swiperContainer.siblings('.swiper-button-next');
        var $navPrev = $swiperContainer.siblings('.swiper-button-prev');

        if (slideCount <= 2) {
            $pagination.hide();
            $navNext.hide();
            $navPrev.hide();
        }

        var cmsCoverSwiper = new Swiper($swiperContainer[0], {
            slidesPerView: 2,
            slidesPerGroup: 2,
            spaceBetween: 20,
            preloadImages: false,
            lazy: true,
            autoplay: false,
            navigation: {
                nextEl: $navNext[0],
                prevEl: $navPrev[0],
            },
            pagination: {
                el: $pagination[0],
                type: 'progressbar',
            },
        });
    });

    /********** CMS PAGE MODULE 29 PICTURE TEXT CTA **********/
    $('.cms-page-module-body.module-29-picture-text-cta .cms-slider-items').each(function() {

        var $swiperContainer = $(this);
        var slideCount = $swiperContainer.find('.swiper-slide').length;
        var $pagination = $swiperContainer.parent().find('.swiper-container + .swiper-pagination');
        var $navNext = $swiperContainer.siblings('.swiper-button-next');
        var $navPrev = $swiperContainer.siblings('.swiper-button-prev');


        if (slideCount <= 4) {
            $pagination.hide();
            $navNext.hide();
            $navPrev.hide();
        }

        if (slideCount < 4) {
            $swiperContainer.addClass('no-scrolled');
        }

        var cmsCoverSwiper = new Swiper($swiperContainer[0], {
            slidesPerView: 4,
            slidesPerGroup: 1,
            spaceBetween: 20,
            preloadImages: false,
            lazy: true,
            autoplay: false,
            watchOverflow: true,
            roundLengths: true,
            navigation: {
                nextEl: $navNext[0],
                prevEl: $navPrev[0],
            },
            pagination: {
                el: $pagination[0],
                type: 'progressbar',
            },
        });
    });

    /********** CMS PAGE MODULE 20 PICTURE TEXT **********/
    $('.cms-page-module-body.module-20-picture-text .cms-slider-items').each(function() {

        var $swiperContainer = $(this);
        var slideCount = $swiperContainer.find('.swiper-slide').length;
        var $pagination = $swiperContainer.parent().find('.swiper-container + .swiper-pagination');
        var $navNext = $swiperContainer.siblings('.swiper-button-next');
        var $navPrev = $swiperContainer.siblings('.swiper-button-prev');


        if (slideCount <= 5) {
            $pagination.hide();
            $navNext.hide();
            $navPrev.hide();
        }

        var cmsCoverSwiper = new Swiper($swiperContainer[0], {
            slidesPerView: 5,
            spaceBetween: 20,
            preloadImages: false,
            lazy: true,
            autoplay: false,
            navigation: {
                nextEl: $navNext[0],
                prevEl: $navPrev[0],
            },
            pagination: {
                el: $pagination[0],
                type: 'progressbar',
            },
        });
    });
    /********** CMS PAGE MODULE 22 COVER PICTURE TEXT CTA **********/
    $('.cms-page-module-body.module-22-picture-text-cta .cms-slider-items').each(function() {
        
        var $swiperContainer = $(this);
        var slideCount = $swiperContainer.find('.swiper-slide').length;
        var $pagination = $swiperContainer.parent().find('.swiper-container + .swiper-pagination');


        if (slideCount <= 1) {
            $pagination.hide();
        }

        var cmsCoverSwiper = new Swiper($swiperContainer[0], {
            slidesPerView: 1,
            spaceBetween: 0,
            preloadImages: false,
            lazy: true,
            autoplay: false,
            pagination: {
                el: $pagination[0],
                type: 'bullets',
            },
        });
    });

    /********** CMS PAGE MODULE 23 COVER PICTURE TEXT CTA **********/
    $('.cms-page-module-body.module-23-picture-text .cms-slider-items').each(function() {
        console.log($(this).find('.swiper-slide').length);
        if ($(this).find('.swiper-slide').length > 2) {
            var $swiperContainer = $(this);
            var slideCount = $swiperContainer.find('.swiper-slide').length;
            var $pagination = $swiperContainer.parent().find('.swiper-container + .swiper-pagination');
            var $navNext = $swiperContainer.siblings('.swiper-button-next');
            var $navPrev = $swiperContainer.siblings('.swiper-button-prev');

            var cmsCoverSwiper = new Swiper($swiperContainer[0], {
                slidesPerView: 'auto',
                spaceBetween: 20,
                autoplay: false,
                navigation: {
                    nextEl: $navNext[0],
                    prevEl: $navPrev[0],
                },
                pagination: {
                    el: $pagination[0],
                    type: 'progressbar',
                },
            });
        }
    });

    $('.gondole_swiper.swiperTg').each(function() {
        if ($(this).find('.swiper-slide').length > 1) {
            var gondoleHomeSwiper = new Swiper($(this)[0], {
                preloadImages: false,
                slidesPerView: 5,
                slidesPerGroup : 5,
                spaceBetween: 10,
                pagination: {
                    el: $(this).parent().find('.swiper-container + .swiper-pagination')[0],
                    type: 'progressbar',
                },
                navigation: {
                    nextEl: $(this).parent().find('.swiper-button-next')[0],
                    prevEl: $(this).parent().find('.swiper-button-prev')[0],
                },
                breakpoints: {
                    1280: {
                        slidesPerView: 5,
                    }
                }
            });
        }
    });

    $('.tete_de_gondole_par_5').each(function(e) {
        var id_tete_de_gondole_par_5 = $(this).attr('id');

        if ($(this).find('.swiper-slide').length > 1) {
            var tete_de_gondole_par_5 = new Swiper('#' + id_tete_de_gondole_par_5, {
                preloadImages: false,
                slidesPerView: 3,
                slidesPerGroup : 1,
                spaceBetween: 10,
                pagination: {
                    el: '#' + id_tete_de_gondole_par_5 + ' + .tete_de_gondole_nav .swiper-pagination',
                    type: 'progressbar',
                },
                navigation: {
                    nextEl: '#' + id_tete_de_gondole_par_5 + ' + .tete_de_gondole_nav .tete_de_gondole-button-next',
                    prevEl: '#' + id_tete_de_gondole_par_5 + ' + .tete_de_gondole_nav .tete_de_gondole-button-prev',
                },
                breakpoints: {
                    1120: {
                        slidesPerView: 5,
                    }
                }
            });
        }
    });

    if ($('.tete_de_gondole_no_nav .swiper-slide').length > 1) {
        $('.tete_de_gondole_no_nav').each(function(e) {
            var id_tete_de_gondole_no_nav = $(this).attr('id');

            var tete_de_gondole_no_nav = new Swiper('#' + id_tete_de_gondole_no_nav, {
                preloadImages: false,
                slidesPerView: 3,
                slidesPerGroup : 1,
                spaceBetween: 10,
                breakpoints: {
                    1120: {
                        slidesPerView: 5,
                    }
                }
            });
        });
    }

    if ($('.tete_de_gondole_grid_4 .swiper-slide').length > 1) {
        var gondoleHomeSwiper = new Swiper('.tete_de_gondole_grid_4', {
            slidesPerView: 2,
            grid: {
                rows: 2,
            },
            spaceBetween: 30,
        });
    }

    initAchatExpressSwipers();

    /********** PRODUCT DETAILS PAGE **********/
    // Check direct swiper-slides (because there are also swiper-slides in achat express)
    var $gondolSlides = $("#gondole_complete .swiper-wrapper>.swiper-slide");

    if ($gondolSlides.length > 1) {

        if ($('.similar_product_pagi').length && !$('.similar_product_pagi').is(':visible')) {
            $('.similar_product_pagi').show();
        }
        var productThumbsa = new Swiper('#gondole_complete', {
            loop: false,
            slidesPerView: 3,
            slidesPerGroup: 3,
            spaceBetween: 10,

            navigation: {
                nextEl: '#gondole_complete .swiper-button-next',
                prevEl: '#gondole_complete .swiper-button-prev',
            },
            pagination: {
                el: '.gondole_complete_pagination',
                type: 'progressbar',
            },
        });

        // Si 3 slides ou moins, cacher la navigation et la progress bar
        if ($gondolSlides.length <= 3) {
            $('#gondole_complete .swiper-button-next, #gondole_complete .swiper-button-prev').hide();
            $('.gondole_complete_pagination').hide();
            $('.similar_product_pagi').hide();
        }
    } else {
        $("#gondole_complete").addClass('no_swiper');

        if ($('.similar_product_pagi').length) {
            $('.similar_product_pagi').hide();
        }
    }

        // Check direct swiper-slides (because there are also swiper-slides in achat express)
        if ($("#associations_by_rayon .swiper-wrapper>.swiper-slide").length > 4) {
            if ($('.associations_by_rayon_pagi').length && !$('.associations_by_rayon_pagi').is(':visible')) {
                $('.associations_by_rayon_pagi').show();
            }
            var associationsByRayonSwiper = new Swiper('#associations_by_rayon', {
                loop: false,
                slidesPerView: 3.2,
                spaceBetween: 10,
                watchOverflow: true,

                navigation: {
                    nextEl: '.associations_by_rayon_pagi .swiper-button-next',
                    prevEl: '.associations_by_rayon_pagi .swiper-button-prev',
                },
                pagination: {
                    el: '.associations_by_rayon_pagination',
                    type: 'progressbar',
                },
            });
        } else {
            $("#associations_by_rayon").addClass('no_swiper');
            // Hide navigation buttons and scrollbar when no swiper
            $('#associations_by_rayon').closest('.wrap_gondole').find('.gamme_prev, .gamme_next, .swiper-scrollbar, .associations_by_rayon_pagi, .associations_by_rayon_pagination').hide();
            if ($('.associations_by_rayon_pagi').length) {
                $('.associations_by_rayon_pagi .swiper-button-prev').hide();
            }
            if ($('.associations_by_rayon_pagi .swiper-button-next').length) {
                $('.associations_by_rayon_pagi .swiper-button-next').hide();
            }
        }

    // Check direct swiper-slides (because there are also swiper-slides in achat express)
    if ($("#gondole_aimerez .swiper-wrapper>.swiper-slide").length > 1) {

        if ($('.complementary_product_pagi').length && !$('.complementary_product_pagi').is(':visible')) {
            $('.complementary_product_pagi').show();
        }
        var productThumbsaa = new Swiper('#gondole_aimerez', {
            loop: false,
            slidesPerView: 5,
            slidesPerGroup: 5,
            spaceBetween: 10,

            navigation: {
                nextEl: '#gondole_aimerez .swiper-button-nexta',
                prevEl: '#gondole_aimerez .swiper-button-preva',
            },
            pagination: {
                el: '.complementary_product_pagination',
                type: 'progressbar',
            },
        });
    } else {

        $("#gondole_aimerez").addClass('no_swiper');

        if ($('.swiper-button-nexta').length) {
            $('.swiper-button-nexta').hide();
        }
        if ($('.swiper-button-preva').length) {
            $('.swiper-button-preva').hide();
        }

        if ($('.complementary_product_pagi').length) {
            $('.complementary_product_pagi').hide();
        }
        if ($('.complementary_product_pagination').length) {
            $('.complementary_product_pagination').hide();
        }
    }

    if (($('#dimension_carac').length) > 0) {
        window.setTimeout(function() {
            $('#dimension_carac .wrapping').overlayScrollbars({});
        }, 1000);
    }

    $('#productVisitedSwiper').each(function() {
        var $swiperContainer = $(this);
        var $pagination = $swiperContainer.siblings('.product_visited_pagination');
        var $navigation = $swiperContainer.siblings('.product_visited_pagi');

        // Compter uniquement les slides directs dans .swiper-wrapper (comme dans n_common.js)
        // Utiliser la même logique que n_common.js : compter les .assoc enfants directs de .swiper-wrapper
        var slideCount = $swiperContainer.find('.swiper-wrapper > .assoc').length;

        if (this.swiper) {
            return;
        }

        // Initialiser si >= 1 slide
        if (slideCount >= 1) {
            // Cacher la pagination et les boutons si < 5 slides
            if (slideCount <= 5) {
                if ($navigation.length) {
                    $navigation.hide();
                }
                if ($pagination.length) {
                    $pagination.hide();
                }
            } else {
                // Afficher les contrôles si >= 5 slides
                if ($navigation.length && !$navigation.is(':visible')) {
                    $navigation.show();
                }
                if ($pagination.length && !$pagination.is(':visible')) {
                    $pagination.show();
                }
            }

            // Utiliser l'élément DOM directement au lieu du sélecteur
            var productThumbsaa = new Swiper($swiperContainer[0], {
                spaceBetween: 10,
                loop: false,
                slidesPerView: 5,
                navigation: {
                    nextEl: '.product_visited_pagi .swiper-button-next',
                    prevEl: '.product_visited_pagi .swiper-button-prev',
                },
                pagination: $pagination.length ? {
                    el: $pagination[0],
                    type: 'progressbar',
                } : {
                    el: '.product_visited_pagination',
                    type: 'progressbar',
                },
                on: {
                    init: function () {
                        var isWindowLarge = $(window).outerWidth() > 1300;
                        var swiperSlideLength = $('#algolia_visited_articles #productVisitedSwiper .swiper-slide').length;
                        var swiperComponents = '#algolia_visited_articles .swiper-button-next, #algolia_visited_articles .swiper-button-prev, #algolia_visited_articles .swiper-scrollbar, #algolia_visited_articles .swiper-pagination';

                        isWindowLarge && swiperSlideLength < 5 ? $(swiperComponents).addClass('cache') : $(swiperComponents).removeClass('cache');
                    }
                }
            });
        } else {
            $(this).addClass('no_swiper');
            // Masquer les boutons et la pagination si le swiper n'est pas initialisé
            if ($('.product_visited_pagi').length) {
                $('.product_visited_pagi').hide();
            }
            if ($('.product_visited_pagination').length) {
                $('.product_visited_pagination').hide();
            }
        }
    });

    // HEADER SCROLLBARS
    if ($('#wishlist_list').length) {
        $('#wishlist_list').overlayScrollbars({
            scrollbars: {
                autoHide: "leave",
                autoHideDelay: 0,
            }
        });
    }

    if ($('#order_basket_list').length) {
        $('#order_basket_list').overlayScrollbars({
            scrollbars: {
                autoHide: "leave",
                autoHideDelay: 0,
            }
        });
    }

    //CMS SWIPER
    if ($("#articles_list_swiper").length) {
        cnt = 0;
        $("#articles_list_swiper.swiper-container").each(function(e){
            cnt++;
            $(this).addClass('article-swiper-init-'+ cnt);
            if ($(this).find('.swiper-slide').length > 1) {
                var articleCms = new Swiper('.article-swiper-init-'+ cnt, {
                    spaceBetween: 50,
                    slidesPerView: 3,
                    pagination: {
                        el: '.swiper-pagination',
                        type: 'progressbar',
                    },
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev',
                    },
                });
            }
        })
    }

    //Signup module - change mastered trad
    if ($('.signup-module .w-input.w-email-input .w-input-label span').length) {
        $('.signup-module .w-input.w-email-input .w-input-label span').text(Translator.translate('selection_mail'));
        $('.signup-module .w-input.w-email-input .w-input-label span').addClass('visible');
    }

    /* BACK TO TOP FUNCTION */
    var stickyNavEl = $('#rayon_sticky_nav');
    var backToTopBtn = $('#back_to_top');

    if (stickyNavEl.length > 0) {
        var stickyNavTop = stickyNavEl.offset().top;
    }

    function stickyNav() {
        if (stickyNavEl.length > 0) {
            var scrollTop = $(window).scrollTop(); // our current vertical position from the top

            if (scrollTop > stickyNavTop) {
                stickyNavEl.addClass('sticky');
                $("#cart_top").appendTo(".filters_left");

            } else {
                stickyNavEl.removeClass('sticky');
                $("#cart_top").appendTo(".rightSide");
            }
        }
    };

    stickyNav();

    $(window).scroll(function () {
        stickyNav();

        if ($(window).scrollTop() > 300) {
            backToTopBtn.addClass('show');
        } else {
            backToTopBtn.removeClass('show');
        }
    });

    backToTopBtn.on('click', function (e) {
        e.preventDefault();
        $('html, body').animate({ scrollTop: 0 }, 500, 'linear');
    });

    // Bloc SEO max 900 texte
    if ($('.wrapper_bandeau.bandoBottom').length) {
        var text_element = $('.txt_content');
        var max_characters = 900;

        if (text_element.length > 0) {
            text_element.each(function () {
                var text = $(this).html();

                if (text.length > max_characters) {
                    var summary = build_text_summary($(this), max_characters);

                    //load summary + read more
                    $(this).css('display','none');
                    $('<div class="rayon_desc_summary">' + summary + ' <a class="see_more_txt">' + Translator.translate('read_more') + '</a></div>').insertBefore($(this));
                }
            });

            $(document).on('click', '.see_more_txt', function () {
                $(this).parent().hide();
                $(this).parent().next().show().fadeIn(400).slideDown(400);
            });
        }
    }

    // CMS module (image + text + list) swiper with 6 products per slide
    if ($('#swiperImageTextList .swiper-slide').length > 0) {
        var swiperImageTextList = new Swiper("#swiperImageTextList", {
            slidesPerView: 1, // Display 1 slide per view
            spaceBetween: 30,
            roundLengths: true,
            pagination: {
                el: '#swiperImageTextList > .swiper-pagination',
                type: 'progressbar',
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
        });
    }

    // Init swiper categorie page adv
    $('.swiperCategories').each(function () {
        if ($(this).find('.swiper-slide').length > 1) {
            swiperCategories = new Swiper('.swiperCategories', {
                preloadImages: false,
                slidesPerView: 5.54,
                slidesPerGroup : 5,
                spaceBetween: 19,
                loop: false,
                navigation: {
                    nextEl: '.swiperCategories .swiper-button-next',
                    prevEl: '.swiperCategories .swiper-button-prev',
                }
            });
        } else {
            $(this).addClass("no-arrow");
        }

        if ($(this).find('.swiper-slide').length <= 5) {
            $(this).addClass('center_slides');
        } else {
            $(this).removeClass('center_slides');
        }
    });

    // init swipers reinsurance footer
    if ($("#copyright .swiper-container.wrapper_reinsurance").length) {
        var reinsuranceFooterSwiper = new Swiper('#copyright .swiper-container.wrapper_reinsurance', {
            slidesPerView: 3,
            spaceBetween: 0,
        });
    }
    if ($("#product_selects .swiper-container.wrapper_reinsurance").length) {
        var reinsuranceFpSwiper = new Swiper('#product_selects .swiper-container.wrapper_reinsurance', {
            slidesPerView: 3,
            spaceBetween: 0,
        });
    }

    if ($("#content_pdvBox_new").length) {
        var el = $("#content_pdvBox_new .formulaire .w-contact-form");

        el.find("#clientPrenom").blur(function () {
            validateContactStoreName(el.find("#clientPrenom"));
        });

        el.find("#clientNom").blur(function () {
            validateContactStoreName(el.find("#clientNom"));
        });

        el.find("#clientMail").blur(function() {
            validateContactStoreEmail(el.find("#clientMail"));
        });

        el.find("#numTelephone").blur(function() {
            validateContactStoreTel(el.find("#numTelephone"));
        });

        el.find("#clientMessage").blur(function() {
            validateContactStoreCompulsory(el.find("#clientMessage"));
        });

        el.find("#wrapper_optin").change(function() {
            validationContactMagFormOption(el.find("#wrapper_optin"), el.find("#optin_y"), el.find("#optin_n"));
        });

        el.find("#wrapper_optin_sms").change(function() {
            validationContactMagFormOption(el.find("#wrapper_optin_sms"), el.find("#optin_sms_y"), el.find("#optin_sms_n"));
        });
    }

    if ($(".thumb.recovery_product").length) {
        $('.product_feats_wrapper li.thumb.recovery_product .thumbtitle').click(function() {
            $('.thumb.recovery_product').toggleClass('active');
        });
    };

    if ($('body.cart.step_1').length) {

        if ($('#cart_assoc_wrapper').length) {

            $('#cart_assoc_wrapper').insertAfter($('.cart_main_table.wishlist'));
        }

        initSwiperTunnel();
    }

    if ($('.toggleWrapper').length) {

        $(document).on("click", ".toggleWrapper", function () {

            if ($(this).hasClass('active')) {

                $(this).children('.toggleContent').slideUp();
                $(this).removeClass('active');
            } else {

                $('.toggleContent').slideUp();
                $('.toggleWrapper').removeClass('active');
                $(this).children('.toggleContent').slideDown();
                $(this).addClass('active');
            }
        });
    }

    moveProductOutOfStock();

    if ($('#main_cart_wrapper').length) {

        setTimeout(function () {

            $('#main_cart_wrapper').addClass('displayed');
        }, 150);
    }

    function mirror_cgv_click() {
        let accept_cgv = '#accept_cgv';
        let fake_accept_cgv = '#fake_accept_cgv';
        let btn_cmd_valid = '#btn_cmd_valid';
        let fake_btn_cmd_valid = '#fake_btn_cmd_valid';

        $(fake_accept_cgv).on('click', function () {

            $(accept_cgv).click();

            if ($(accept_cgv).is(':checked')) {

                $(this).addClass('accepted');
                $(this).removeClass('not_accepted');
            } else {

                $(this).removeClass('accepted');
            }
        });

        $(fake_btn_cmd_valid).on('click', function () {

            if ($(accept_cgv).is(':checked')) {

                $(this).addClass('loading');
                $(btn_cmd_valid).click();
            } else {

                $(fake_accept_cgv).addClass('not_accepted');
            }
        });
    }

    if ($('body.cart_delivery_choice').length) {
        mirror_cgv_click();
    }

    if ($('.wrapper_moncompte').length) {

        $('.wrapper_moncompte').addClass('appear');

        if ($('.accountBannerTop').length) {

            $('.accountBannerTop').addClass('appear');
        }
    }

    if ($('body.bankThanks').length) {
        $('.thanksWrapper').addClass('appear');

        if ($('#clientForm').length) {
            document.body.classList.add('thanks_create_account');
            $('.thanksRight').insertAfter('.bankThanksTop h1');
        }
    }

    if ($('#selection-offer-content .color_list.swiper-container').length) {
        new Swiper('.color_list.swiper-container', {
            slidesPerView: 4,
            spaceBetween: 10,
            navigation: {
                nextEl: '.nextColour',
                prevEl: '.prevColour',
            }
        });
    }

    loadTgSwiper();
});

window.addEventListener('scroll', loadTgSwiper);

function loadTgSwiper() {
    // Init tgHomeSwiper page adv
    $('.gondole_swiper.page-adv').each(function () {
        if (isInViewport($(this)) && $(this).find('.swiper-slide').length > 1) {
            var tgHomeSwiper = new Swiper($(this)[0], {
                preloadImages: false,
                slidesPerView: 5,
                slidesPerGroup : 5,
                spaceBetween: 10,
                pagination: {
                    el:  $(this).parent().find('.swiper-container + .swiper-pagination')[0],
                    type: 'progressbar',
                },
                navigation: {
                    nextEl: $(this).parent().find('.swiper-button-next')[0],
                    prevEl: $(this).parent().find('.swiper-button-prev')[0],
                },
                breakpoints: {
                    1280: {
                        slidesPerView: 5,
                    },
                    1024: {
                        slidesPerView: 4,
                    }
                }
            });
        }
    });
}

function promo_injectHoverColor(event) {
    if ($(event.target).hasClass('promo_color_label')) {
        if ($('.selection-offer-content .promo_color_choice').length) {
            $(event.target).closest('form').find('.chosen_color').html($(event.target).attr('title'));
        }
    }
}

function promo_injectChosenColor(event) {
    var closestForm = $(event.target).closest('form');
    // since the event.target is the input, we need to find the label that is associated with it - get the input's id and find the label with that for attribute
    var linkedLabel = closestForm.find('label[for="' + $(event.target).attr('id') + '"]');

    closestForm.find('.chosen_color').html(linkedLabel.attr('title')); // title from the label
    closestForm.find('.visuOfferedProd').attr('src', $(event.target).data('pic')); // picture and product ID stocked in the input
    closestForm.find('input[name="product_id"]').val($(event.target).data('product-id'));
}

$(document).on("click","#btn_top_add_wishlist", function (e) {
    e.preventDefault();
    selectedProducts = [];
    var isConnected = true;

    $(".remove_top_wishlist").each(function( index ){
        var id = $(this).attr("data-id");
        var prodId = $(this).attr("data-produit-id");
        var colorId = $(this).attr("data-color-id");
        var sizeId = $(this).attr("data-size-id");

        if (id != '') {
            selectedProducts.push(id);
        } else {
            isConnected = false;
            selectedProducts.push({
                productId: prodId,
                colorId: colorId,
                sizeId: sizeId
            });
        }
    });
    moveProductFromWishlistToCart(selectedProducts, isConnected);
});

/*******************************************************************************************************/
/* CUSTOM FUNCTIONS
/*******************************************************************************************************/

function triggerShad(shad, action) {
    shad = shad ? ('#shad_' + shad):'#shad' ;

    if (action && action == 'add') {
        $(shad).addClass('actif');
    } else if (action) {
        $(shad).removeClass('actif');
    } else {
        return;
    }
}

function remove_shad() {
    $('#shad').removeClass('actif');
    $('#shad_menu').removeClass('actif');
}

// Search function to trigger form btns

function triggerFormAction(action) {
    if (action !== undefined && action !== '') {
        if ($('[data-action="'+ action +'"]')) {
            $('[data-action="'+ action +'"]').click();
        }
    }
}

// function in order to close Wshop search results and display searchPage
function closeWshopSearch() {
    if ($('.search_shad').is(':visible')) {
        $('.search_shad').fadeOut(100);
        setTimeout(function() {
            $('.search_results_wrapper').slideUp(10);
        }, 100);
    }
}

// count filters in rayon
function countItemFilter(input, translation) {
    var filterName = input.name;
    if (filterName === 'custom_data') {
        var parent = $(input).data('parentname') || translation; // typologie-de-produit
        var filters = $('#filter_sticky input:checked[name="custom_data"][data-parentname="' + parent + '"]');
        var countFilters = filters.length;

        var $btn = $("#trigger_filtre [data-filtername='" + parent + "']");
        if ($btn.length > 0) {
            if (countFilters > 0) {
                if ($btn.find('.count_filters').length) $btn.find('.count_filters').html(' (' + countFilters + ')');
                else $btn.append('<span class="count_filters"> (' + countFilters + ') </span>');
            } else {
                $btn.find('.count_filters').remove();
            }
        }
        return;
    }
    var filters = $('input:checked[name='+ filterName +']');
    var countFilters = filters.length

    if (countFilters > 0) {
        if ($("#trigger_filtre [data-filtername='" + filterName + "']").length) {
            if ($("#trigger_filtre [data-filtername='" + filterName + "']").find('.count_filters').length) {
                $("#trigger_filtre [data-filtername='" + filterName + "'] .count_filters").html(' (' + countFilters + ')');
            } else {
                $("#trigger_filtre [data-filtername='" + filterName + "']").append('<span class="count_filters"> ('+ countFilters + ') </span>');
            }
        } else if ($("#trigger_filtre [data-filtername='" + translation + "']").length) {
            if ($("#trigger_filtre [data-filtername='" + translation + "']").find('.count_filters').length) {
                $("#trigger_filtre [data-filtername='" + translation + "'] .count_filters").html(' (' + countFilters + ')');
            } else {
                $("#trigger_filtre [data-filtername='" + translation + "']").append('<span class="count_filters"> ('+ countFilters + ') </span>');
            }
        }
    } else {
        if ($("#trigger_filtre .filtre_elem .count_filters").length) {
            $("#trigger_filtre .filtre_elem .count_filters").remove();
        }
    }
}

function initAchatExpressSwipers() {

    var arrayElement = ['productColorFieldset', 'productSizeFieldset'];

    for (var elementSwiper of arrayElement) {
        if ($("#list_item .ligne_form." + elementSwiper + " .choices_list .form_itm").length >= 1) {
            $('#list_item .ligne_form.' + elementSwiper).each(function(e) {
                var id = $(this).attr('id');
                new Swiper('#' + id + ' .swiper-container' , {
                    slidesPerView: 3.75,
                    spaceBetween: 16,
                    slideToClickedSlide: true,
                    navigation: {
                        nextEl: '#' + id + ' .swiper-button-next',
                        prevEl: '#' + id + ' .swiper-button-prev',
                    },
                    pagination: {
                        el: '#' + id + ' .swiper-pagination',
                        type: 'progress',
                    },
                });
            })
        }

    }
}

function closeAE() {
    var ae_blocs = $('.ae_bloc');

    if (ae_blocs.length > 1) {
        ae_blocs.each(function() {
            if ($(this).is(':visible')) {
                $(this).fadeOut(600);
            }
        });
    } else if (ae_blocs == 1) {
        if (ae_blocs.is(':visible')) {
            ae_blocs.fadeOut(600);
        }
    }
}

function build_text_summary(text_el, max_characters) {
    var text = text_el.html();

    if (text.length > max_characters) {
        //slice text to defined length
        var summary = text.slice(0, max_characters);

        //check for slice through html tag
        var position = summary.lastIndexOf('<');

        if (position) {
            var check = summary.substring(position);

            //fix slicing if in middle on html tag
            if (check !== '' && check.indexOf('>') == -1) {
                //slice text to correct length
                summary = summary.slice(0,position);

                //remove <br> at summaryning and end of text
                summary = summary.replace(/^(\s*<br\s*\/?\s*>\s*)*|(\s*<br\s*\/?\s*>\s*)*\s*$/gm, '')
            }
        }

        //fix unclosed tags
        summary = fix_unclosed_tags(summary, '...');

        return summary;
    }

    return text;
}

function fix_unclosed_tags(str, end_string) {
    var tags = ["a", "span", "div", "ul", "li", "h1", "h2", "h3", "h4", "h5", "h6", "p", "table", "tr", "td", "b", "i", "u", "strong"];
    var mismatches = [];
    var closing_tag = false;

    tags.forEach(function(tag) {
        var pattern_open = '<' + tag + '( |>)';
        var pattern_close = '</' + tag + '>';
        var diff_count = (str.match(new RegExp(pattern_open,'g')) || []).length - (str.match(new RegExp(pattern_close,'g')) || []).length;

        if (diff_count != 0) {
            closing_tag = true;
            str = str + end_string + '</' + tag + '>';
        }
    });

    if (closing_tag == false) {
        str = str + end_string;
    }

    return str;
}

function validationContactMagFormCompulsory (field) {
    if (field.val() === ''){
        field.addClass("inputErr");
        return false;
    }

    field.removeClass('inputErr');
    return true;
}

function validationContactMagFormEmail (field) {
    if (field.val() === '' || validateEmail(field.val()) === false){
        field.addClass("inputErr");
        return false;
    }

    field.removeClass('inputErr');
    return true;
}

function validationContactMagFormTel (field) {
    if ( field.val() === '' || field.intlTelInput( "isValidNumber" ) === false || field.intlTelInput( "getNumberType" ) == 0 ) {
        field.addClass("inputErr");
        return false;
    }

    field.removeClass('inputErr');
    return true;
}

function validationContactMagFormOption (field, opt1, opt2) {
    if (field.length && !opt1.is(":checked") && !opt2.is(":checked")){
        field.addClass("inputErr");
        return false;
    }

    field.removeClass("inputErr");
    return true;
}

function forceNumOnly( elmt ) {
    elmt.value = elmt.value.replace( /[^0-9. ]/g, '' ).replace( /(\..*)\./g, '$1' );
}

// Checks whether email adresss valid
function validateEmail(email) {
    var rex = /^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i;

    return rex.test(email);
}

/**
 * Contact store form validators (matching w-info-formV2 rules)
 * Uses w-has-error class on parent .w-input label and shows/hides data-error spans.
 */
function contactStoreShowError(field, errorType) {
    var wrapper = field.closest('.w-input');
    wrapper.addClass('w-has-error');
    wrapper.find('.w-input-note[data-error]').hide();
    wrapper.find('.w-input-note[data-error="' + errorType + '"]').show();
}

function contactStoreClearError(field) {
    var wrapper = field.closest('.w-input');
    wrapper.removeClass('w-has-error');
    wrapper.find('.w-input-note[data-error]').hide();
}

function validateContactStoreName(field) {
    var val = field.val().trim();
    var alphaOnlyRegex = /^[\p{L}\- ']+$/u;

    if (val === '') {
        contactStoreShowError(field, 'required');
        return false;
    }

    if (val.length < 2) {
        contactStoreShowError(field, 'minLength');
        return false;
    }

    if (val.length > 127) {
        contactStoreShowError(field, 'maxLength');
        return false;
    }

    if (!alphaOnlyRegex.test(val)) {
        contactStoreShowError(field, 'alphaOnly');
        return false;
    }

    contactStoreClearError(field);
    return true;
}

function validateContactStoreEmail(field) {
    var val = field.val().trim();

    if (val === '') {
        contactStoreShowError(field, 'required');
        return false;
    }

    if (!validateEmail(val)) {
        contactStoreShowError(field, 'email');
        return false;
    }

    contactStoreClearError(field);
    return true;
}

function validateContactStoreTel(field) {
    var val = field.val().trim();

    if (val === '') {
        contactStoreShowError(field, 'required');
        return false;
    }

    if (typeof field.intlTelInput === 'function' && field.intlTelInput("isValidNumber") === false) {
        contactStoreShowError(field, 'tel');
        return false;
    }

    contactStoreClearError(field);
    return true;
}

function validateContactStoreCompulsory(field) {
    var val = field.val().trim();

    if (val === '') {
        contactStoreShowError(field, 'required');
        return false;
    }

    contactStoreClearError(field);
    return true;
}

function mirrorOptoutCheckbox() {
    const fakeOptoutReplacement = '.nbDenyOptinSimple';
    const fakeOptoutCheckbox = '#deny-optin input[name="optout-checkbox"]';
    const fakeOptoutContainer = '#deny-optin';
    const trueOptoutRadio = '.optin_container input[type="radio"][value="0"]';
    const trueOptinRadio = '.optin_container input[type="radio"][value="1"]';

    // Sync radios and fake checkbox when user interacts
    document.addEventListener('change', (e) => {
        // Check the type of the fake checkbox's behavior
        const behavior = document.querySelector(fakeOptoutCheckbox).getAttribute('type') || 'radio';

        if (behavior === 'checkbox') {
            if (e.target.matches(fakeOptoutCheckbox)) {
                const optout = document.querySelector(trueOptoutRadio);
                if (e.target.checked) {
                    // If checked, check the opt-out radio
                    if (optout) optout.checked = true;
                } else {
                    // If unchecked, uncheck the opt-out radio
                    // DON'T CHECK THE OPT-IN RADIO HERE - else it WOULD TRIGGER A (RE)SUBSCRIPTION WITHOUT USER CONSENT
                    if (optout) optout.checked = false;
                }
            }
        } else if (behavior === 'radio') {
            // If the fake checkbox behaves as a radio linked to the opt-in radio, we synchronize both ways
            if (e.target.matches(fakeOptoutCheckbox)) {
                const optout = document.querySelector(trueOptoutRadio);
                if (optout) optout.checked = e.target.checked;
            } else if (e.target.matches(trueOptinRadio)) {
                const fake = document.querySelector(fakeOptoutCheckbox);
                if (fake) fake.checked = !e.target.checked;
            }
        } else {
            console.warn('mirrorOptoutCheckbox: unknown behavior for optout checkbox');
        }
    });

    // Observe DOM for the opt-in/out radios being added or removed
    const observer = new MutationObserver((mutations, obs) => {

        // Hide fake checkbox if opt-in radio disappears
        if (!document.querySelector(trueOptinRadio)) {
            $(fakeOptoutReplacement).show();
            $(fakeOptoutContainer).fadeOut();
            return;
        }

        // Show fake checkbox once opt-in radio is inserted
        if (document.querySelector(trueOptinRadio)) {
            $(fakeOptoutReplacement).hide();
            $(fakeOptoutContainer).fadeIn();

            // Mirror state of the real opt-out radio
            // First, check if opt-ins are displayed or not: this will change the checkbox's behavior
            if (document.querySelector('#show-optin') && document.querySelector('#show-optin').value === '0') {
                // If they're hidden, we set the opt-out as a true checkbox
                const fake = document.querySelector(fakeOptoutCheckbox);
                fake.setAttribute('type', 'checkbox');
            } else {
                // If they're shown, we set the opt-out as a radio linked to the opt-in radio
                const optout = document.querySelector(trueOptoutRadio)
                const fake = document.querySelector(fakeOptoutCheckbox);
                fake.setAttribute('type', 'radio');
                if (optout && fake) fake.checked = optout.checked;
            }

            return;
        }
    });

    observer.observe(document.body, { childList: true, subtree: true });
}

window.addEventListener('DOMContentLoaded', () => {
    let pageAdvance = document.querySelector('body.cms_page_new') ? document.querySelector('body.cms_page_new') : document.querySelector('body.cms_page');
    if (!pageAdvance) {
        pageAdvance = document.querySelector('body.cms_subcategory');
    }
    const anchor = document.querySelector('.ancre_type');

    if (pageAdvance) {
        if (anchor) {
            setTimeout(() => {
                if (window.location.hash) {
                    const element = document.getElementById(window.location.hash.substring(1));
                    if (element) {
                        $("html, body").animate({scrollTop: $(element).offset().top - 80 }, 600);
                    }
                }
            }, 600);
        }
    }

    // we need to wait for the document to be fully loaded, so we can triiger the function mirrorOptoutCheckbox()
    // Only enable on login page and tunnel
    if (document.body.classList.contains('body_login')) {
        mirrorOptoutCheckbox();
    }
});
// Debounce timer for quantity changes
var qteDebounceTimer = null;
var qteInProgress = false;

function changeQte(type) {
    var types = ['plus', 'less'];

    if (!types.includes(type)) {
        return;
    }

    // Prevent changes while a request is in progress
    if (qteInProgress) {
        return;
    }

    var item = this.getValue('item_id', parseFloat);
    var cartelem = document.getElementById("cart_total");
    var qtty = this.getValue('selected_qte', parseFloat);
    var context = this;
    var dataElem = this.querySelector('[data-max-qte]');

    // Use data attribute instead of value for better control
    var remainingValue = parseFloat(dataElem.getAttribute('data-max-qte') || 0);

    // Update quantity immediately for UI feedback
    switch (type) {
        case 'plus':
            // If remainingValue <= 0, we cannot add more
            if (remainingValue <= 0) {
                return;  // Exit early, don't increment
            }

            qtty += 1;
            remainingValue -= 1;
            // Update data attribute immediately to prevent multiple clicks
            dataElem.setAttribute('data-max-qte', remainingValue);
            break;

        case 'less':
            qtty -= 1;

            // Prevent quantity from going below 1
            if (qtty < 1) {
                qtty = 1;
                return;
            }

            remainingValue += 1;
            // Update data attribute immediately
            dataElem.setAttribute('data-max-qte', remainingValue);
            break;
    }

    // Update the hidden input value for next calls
    var selectedQteInput = context.querySelector('[name="selected_qte"]');
    if (selectedQteInput) {
        selectedQteInput.value = qtty;
    }

    // Clear existing timer
    if (qteDebounceTimer) {
        clearTimeout(qteDebounceTimer);
    }

    // Show loader
    cartelem.setAttribute('is-loading', '');

    // Set new timer to execute after user stops clicking (800ms delay)
    qteDebounceTimer = setTimeout(function() {
        // Prevent multiple simultaneous requests
        if (qteInProgress) {
            return;
        }

        qteInProgress = true;

        $.ajax({
            url: path_relative_root + create_link("order_basket"),
            type: 'post',
            data: {
                action: 'del',
                panierId: item,
                cad: 'non',
                pointcad: 0,
                qteProd: qtty,
                change_qte: true
            },
            cache: false,
            success: function (res) {

                try {
                    res = JSON.parse(res);
                } catch (e) {
                    console.error('JSON ERROR: could not parse data');
                    return false;
                }

                resHtml = $('<div />').html(res.datas);

                document.getElementById('main_cart_wrapper').innerHTML = $('#main_cart_wrapper', resHtml).html();
                if (wShop.$refs.wCouponForm) {
                    wShop.$refs.wCouponForm.reloadBloc += 1;
                }

                //update top cart
                var response = ajax_file("ajax_show_basket.php");
                document.getElementById('cart_top').innerHTML = response;

                /**
                 * Move out of stock products to the top of the cart
                 */
                initSwiperTunnel();

                if (typeof initApplePayExpressCheckout === "function") {
                    initApplePayExpressCheckout();
                }

                if (res.error_message.length) {
                    $('#modboxpromo').find('.texte').html(res.error_message);
                    openMultiShad('modboxpromo');
                }
            },
            complete : function() {
                getWishlistProducts();

                // Enable new function calls
                qteInProgress = false;
                cartelem.removeAttribute('is-loading');
            }
        });
    }, 800); // buffer timing after last click
}

function initSwiperTunnel() {
    var cartWish = $('.cart_main_table.wishlist');
    var cartAssocSlider = $('.cartAssocSlider');

    // Cart cross-sell carousels live inside #main_cart_wrapper, which is fully
    // replaced by the quantity/basket ajax calls: re-init them here so they don't
    // come back as raw stacked slides (mobile does the same in updateCartElements).
    if (typeof initCrossSellCarousels === 'function') {
        initCrossSellCarousels();
    }

    if (cartWish.length) {

        new Swiper(".cart_main_table.wishlist", {
            slidesPerView: 4,
            slidesPerGroup: 4,
            spaceBetween: 15,
            navigation: {
                prevEl: '.cartWishPrev',
                nextEl: '.cartWishNext',
            },
            breakpoints: {
                // when window width is >= 1300px
                1300: {
                    slidesPerView: 4.33
                },
            }
        });
    }

    if (cartAssocSlider.length) {

        new Swiper('.cartAssocSlider', {
            slidesPerView: 4,
            slidesPerGroup: 4,
            spaceBetween: 15,
            navigation: {
                prevEl: '.cartAssocPrev',
                nextEl: '.cartAssocNext',
            },
            breakpoints: {
                // when window width is <= 1300px
                1300: {
                    slidesPerView: 4.33
                },
            }
        });
    }
}

// Update tunnel swipers from APP events
$(window).on('basketToWish_complete', function () {


    $('#wishlist_top').removeClass('active_rollover');

    if ($('.cart_main_table.wishlist').length) {

        window.location.reload();
    }
});

$(window).on('wishToBasket_complete', function () {
    initSwiperTunnel();

    // get the first appearance of .product_line_basket
    var first_product = $('.product_line_basket').first();

    // scroll to first_product position
    if (first_product.length) {
        $('html, body').animate({
            scrollTop: first_product.offset().top - 160
        }, 500);
    } else {
        $('html, body').animate({
            scrollTop: 0
        }, 500);
    }
});

$(window).on('removeFromBasket_success', function () {
    initSwiperTunnel();
});

function updateCartElements() {
    initSwiperTunnel();
}

$(".total_produit").on("click", function () {

    $(this).toggleClass("open");
    $(".total_produit_dropdown").slideToggle();

    if ($(".total_produit_dropdown.scrollable").length) {

        $(".total_produit_dropdown").overlayScrollbars({});
    }
});

$(document).on('click', '.btn_toggle_hours', function (e) {

    $(this).toggleClass('open');
    $(this).next('.openingHours').toggleClass('open');
});
